export * from './tabsMapper';
